import { isProd, isDev } from '@/config/constants'

const ACCOUNT_BASE_URL = isProd
    ? "https://customerrecommendation-api.maersk-digital.net/api/"
    : isDev
        ? "https://api-cdt.maersk.com/gdae2ekv-custrecapidev/api/"
        : "http://localhost:8081/api/";

//User Access
export const postUserAuth = `${ACCOUNT_BASE_URL}authorizeUser`;
export const saveUserActivity = `${ACCOUNT_BASE_URL}saveUserActivity`;
export const getCustomerNames = `${ACCOUNT_BASE_URL}getCustomerNames`;
export const getDistinctSalesManager = `${ACCOUNT_BASE_URL}getDistinctSalesManager`;
export const getDistinctAccountOwners = `${ACCOUNT_BASE_URL}getDistinctAccountOwners`;
export const getDropDownList = `${ACCOUNT_BASE_URL}getDropDownList`;
export const getCustomerLevelDetails = `${ACCOUNT_BASE_URL}getCustomerLevelDetails`;
export const getTradeLevelDetails = `${ACCOUNT_BASE_URL}getTradeLevelDetails`;
export const saveDashboardFilter = `${ACCOUNT_BASE_URL}saveDashboardFilter`;
export const getMonthlyPipelineDetails = `${ACCOUNT_BASE_URL}getMonthlyPipelineDetails`;

export const getTradeLevelReport = `${ACCOUNT_BASE_URL}getTradeLevelReport`;
export const getProductLevelReport = `${ACCOUNT_BASE_URL}getProductLevelReport`;
export const getSalesRegionAreaLevelReport = `${ACCOUNT_BASE_URL}getSalesRegionAreaLevelReport`;
export const getExportRegionLevelReport = `${ACCOUNT_BASE_URL}getExportRegionLevelReport`;
export const getSalesRegionLevelReport = `${ACCOUNT_BASE_URL}getSalesRegionLevelReport`;
export const getSalesAreaLevelReport = `${ACCOUNT_BASE_URL}getSalesAreaLevelReport`;
export const getExportRegionTradeLevelReport = `${ACCOUNT_BASE_URL}getExportRegionTradeLevelReport`;
export const selectedExportRegion = `${ACCOUNT_BASE_URL}selectedExportRegion`;
export const getSalesCountryLevelReport = `${ACCOUNT_BASE_URL}getSalesCountryLevelReport`;
export const saveSFDCUserClick = `${ACCOUNT_BASE_URL}saveSFDCUserClick`;

